import { render, staticRenderFns } from "./RulesModal.vue?vue&type=template&id=9798abaa&"
import script from "./RulesModal.vue?vue&type=script&lang=js&"
export * from "./RulesModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "RulesModal.vue"
export default component.exports